import React from 'react';

// Utility function to format the address
export function formatAddress(billingAddress: string): JSX.Element {
  const firstCommaIndex = billingAddress.indexOf(',');
  const firstWord = billingAddress.slice(0, firstCommaIndex);
  const restOfAddress = billingAddress.slice(firstCommaIndex + 1).trim();

  return (
    <p>
      {firstWord}
      <br />
      {restOfAddress}
    </p>
  );
}
